<template>
    <div class="d-flex flex-fill">

        <div class="container py-3">
            <div class="row justify-content-center h-100">

                <!-- Left Area -->
                <div class="col-sm-12 col-md-12 col-lg-6">
                    <div class="d-flex flex-column w-100 h-100">

                        <!-- <div class="radius-normal py-2 px-3 mb-2 w-100 border-light bg-lighter"> -->
                        <div class="radius-normal py-2 px-3 mb-2 w-100" :style="productColor">
                            <event-details :reservation="reservation" :disabled="isReservationReadOnly && reservation.status != -5" />
                        </div>

                        <div class="border-light radius-normal py-2 px-3 mb-2 w-100 flex-grow-1">
                            <reservation-ticket-prices :reservation="reservation" @toggleEditPax="toggleEditPax" />
                        </div>

                        <div class="">
                            <reservation-other-extras :reservation="reservation" />
                        </div>

                    </div>

                </div>

                <!-- Right Area -->
                <div class="col-sm-12 col-md-12  col-lg-6 mt-sm-2 mt-sm-2 mt-lg-0">
                    <div class="d-flex flex-column w-100 h-100">
                        <!-- <div class="col-sm-12"> -->
                            <div class="border-light radius-normal py-2 flex-grow-1 mb-2">
                                <checkins :disabled="disabled || isEditingPax" :reservation="reservation"></checkins>
                            </div>
                        <!-- </div> -->

                        <!-- <div class="col-sm-12 mt-3"> -->
                            <price-total class="border-light radius-normal" :disabled="disabled" :reservation="reservation"></price-total>
                        <!-- </div> -->
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import reservationTicketPrices from './reservationTicketPrices.vue'
import reservationOtherExtras from './reservationOtherExtras.vue'
import Checkins from '@/tools/modal/ReservationEditV2/TabReservation/Checkins'
import PriceTotal from '@/tools/modal/ReservationEditV2/TabReservation/PriceTotal'
import eventDetails from './eventDetails'
import { mapGetters } from 'vuex';

export default {
    data: function() {
        return {
            isEditingPax: false,
        }
    },
    props:{
        reservation:{
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggleEditPax: function(val) {
            this.isEditingPax = val
            this.$emit('toggleEditPaxReservation', this.isEditingPax) //emit to parent component that totalPax is in edition or not
        }
    },
    components: {
        reservationTicketPrices,
        reservationOtherExtras,
        Checkins,
        PriceTotal,
        eventDetails
    },
    mixins: [
        reservationsMixin
    ]
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabReservation.vue?60f1c52a